module.exports = __webpack_public_path__ + "fonts/NunitoSans-Black.68b8d38.woff";